import dayjs from 'dayjs';
import { IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

export const updateSlotTableHeader = ({ setEditUpdateSlot }) => [
  {
    field: 'week_day',
    headerName: 'Day',
    width: 130,
    renderCell: ({ value }) => dayjs().day(value).format('dddd'),
  },
  {
    field: 'slots',
    headerName: 'Time Slots',
    width: 400,
    renderCell: ({ value }) => {
      const times = [];

      value?.forEach((v) => {
        times.push(`${v?.from_time?.slice(0, 5)} - ${v?.to_time?.slice(0, 5)}`);
      });

      return times?.length ? times.join(', ') : 'No-slot';
    },
  },
  {
    field: 'actions',
    headerName: 'Action',
    width: 150,
    renderCell: ({ row }) => (
      <IconButton color="primary" size="small" onClick={() => setEditUpdateSlot(row)}>
        <EditIcon />
      </IconButton>
    ),
  },
];
